module.exports = __webpack_public_path__ + "static/media/asset-track.5f97ed36.svg";